/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class IconTwo extends React.Component {
  render() {
    return (
      <svg viewBox="0 0 480.002 480.002">
        <path
          fill="none"
          stroke="#827ddc"
          strokeWidth="10"
          d="M80.006 328.002H16.002a7.998 7.998 0 0 0-8 7.996v136.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V336.002a7.998 7.998 0 0 0-7.996-8zm-8.005 136h-48v-120h48v120zM368.006 264.002h-64.004a7.998 7.998 0 0 0-8 7.996v200.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V272.002a7.998 7.998 0 0 0-7.996-8zm-8.005 200h-48v-184h48v184zM272.006 304.002h-64.004a7.998 7.998 0 0 0-8 7.996v160.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V312.002a7.998 7.998 0 0 0-7.996-8zm-8.005 160h-48v-144h48v144zM176.006 208.002h-64.004a7.998 7.998 0 0 0-8 7.996v256.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V216.002a7.998 7.998 0 0 0-7.996-8zm-8.005 256h-48v-240h48v240zM464.006 368.002h-64.004a7.998 7.998 0 0 0-8 7.996v96.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996v-96.004a7.998 7.998 0 0 0-7.996-8zm-8.005 96h-48v-80h48v80z"
        />
        <path
          fill="none"
          stroke="#827ddc"
          strokeWidth="10"
          d="M478.077 175.371a7.966 7.966 0 0 0-1.751-1.525l-32-20.57a7.997 7.997 0 0 0-12.325 6.726v16h-27.719l-61.625-92.438a8.303 8.303 0 0 0-13.312 0l-87.808 131.711L151.353 4.854a7.887 7.887 0 0 0-7.469-4.852 7.986 7.986 0 0 0-7.324 5.07L34.556 264.002H.001v16h40a7.992 7.992 0 0 0 7.441-5.07l96.871-245.891 88.336 206.109a7.995 7.995 0 0 0 14.008 1.289l89.344-134.016 57.344 86.016a7.994 7.994 0 0 0 6.656 3.562h32v16a7.997 7.997 0 0 0 13.207 6.07l32-27.43a7.991 7.991 0 0 0 .869-11.27zm-30.076 15.241v-15.953l10.637 6.836-10.637 9.117z" 
        />
      </svg>
    );
  }
}

export default IconTwo;



// WEBPACK FOOTER //
// ./src/routes/home/img/icons/IconTwo.js